import { motion } from "framer-motion";
import { useI18n } from "@/i18n";
import { legalDoc } from "@/legalContent";

function Doc({ titleKey, kind, testid }) {
  const { t, lang } = useI18n();
  return (
    <div className="max-w-3xl mx-auto px-5 sm:px-8 py-16" data-testid={testid}>
      <motion.h1 initial={{ opacity: 0, y: 12 }} animate={{ opacity: 1, y: 0 }}
        className="font-display text-4xl sm:text-5xl font-black tracking-tighter text-[#2D231F] mb-8">
        {t(titleKey)}
      </motion.h1>
      <div className="bg-white rounded-2xl border border-[#EBDDD3] p-8 text-[#5A4B45] leading-relaxed whitespace-pre-line">
        {legalDoc(kind, lang)}
      </div>
    </div>
  );
}

export function Imprint() {
  return <Doc titleKey="imprint.title" kind="imprint" testid="imprint-page" />;
}

export function Privacy() {
  return <Doc titleKey="privacy.title" kind="privacy" testid="privacy-page" />;
}
